import script from "./TransferSelectControllerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferSelectControllerPage.vue?vue&type=script&setup=true&lang=js"

import "./TransferSelectControllerPage.vue?vue&type=style&index=0&id=05698844&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05698844"]])

export default __exports__